import {Injectable, OnInit} from '@angular/core';
import {
  CanActivate,
  CanActivateChild,
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
  UrlTree,
  Router
} from '@angular/router';
import { ToastrService } from 'ngx-toastr';

@Injectable({
  providedIn: 'root'
})
export class AuthGuard implements CanActivate {
  constructor(
    private router: Router,
    private toastr: ToastrService
  ) {}

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): boolean {

    const authToken = localStorage.getItem('authToken');
    const userType = localStorage.getItem('userType');

    // Session expired / invalid
    if (!authToken || !userType) {
      this.toastr.warning('Session expired, please login');

      // Save attempted URL
      localStorage.setItem('redirectAfterLogin', state.url);

      this.router.navigate(['/login']);
      return false;
    }

    return true; // allow access
  }
}
